import * as React from 'react';

function SvgFilterHome(props) {
  return (
    <svg width={14} height={14} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7 4.103l5.25 4.02v5.361h-3.5V9.911h-3.5v3.573h-3.5v-5.36L7 4.103zM7 .516l7 5.548v2.261L7 2.778 0 8.325v-2.26l7-5.55z" />
    </svg>
  );
}

export default SvgFilterHome;
